import { RefObject } from "react";

export const MAP_URL = "https://data.apps.fao.org/ex-act/?clean&noBanner=1";

const MapIframe = ({ iframeRef, width }: { iframeRef: RefObject<HTMLIFrameElement>, width?: string }) => {
  const isProd = process.env.REACT_APP_ENVIRONMENT === 'PROD';
  const url = isProd ? "https://data.apps.fao.org/ex-act/?clean" : "https://data-dev.review.fao.org/?clean";
  // https://data.apps.fao.org/ex-act/

  return (
    <div className="map-iframe-container">
      <iframe
        ref={iframeRef}
        src={MAP_URL}
        style={{
          width: width || '750px',
          border: 'none',
          aspectRatio: '1',
        }}
        title="FAO Ex-Act Map"
        allowFullScreen
      />
    </div>
  );
};

export default MapIframe;